import forEach from 'lodash/forEach';
import clone from 'lodash/clone';
import isNull from 'lodash/isNull';
import Animate from '../utils/animate';
import * as Config from '../config';

/*
<div class="tile <?= $term->slug ?>">
    <a href="<?php the_sub_field('url') ?>">
        <span class="wrap">
            <span class="title"><?php the_sub_field('title'); ?></span>
            <span class="little-btn">Learn More</span>
        </span>
        <span class="mask"></span>
    </a>
    <img src="<?php echo get_sub_field('background_image')['url']; ?>" alt="" class="bg">
</div>
*/
const itemsPerRow = [1, 1, 2, 3];

export default class Filters {
    constructor({el}) {
        this.allFilters = window.TC.fillers;
        this.el = el;
        const defaultOptions = {
            animation: 'default',
            initialFilter: 'all',
            itemSelector: 'article'
        };
        const moduleOptions = JSON.parse(el.getAttribute('data-module-options'));

        this.options = {
            ...defaultOptions,
            ...moduleOptions
        };

        this.articles = this.el.querySelectorAll(this.options.itemSelector);
        this.filters = this.el.querySelectorAll('#project-filters li a');
        this.header = this.el.querySelector('h2');
        this.grid = this.el.querySelector('.grid');

        this.slugs = [];
        forEach(this.filters, filter => {
            this.slugs.push(filter.getAttribute('data-filter-slug'));
        });

        this.fill();
        this.bind();

        if (this.options.animation === 'shrink') {
            this.setHeights();
        }

        if (this.options.initialFilter !== 'all') {
            const filter = this.options.initialFilter;
            const filterEl = this.el.querySelector(`[data-filter-slug="${filter}"]`).parentNode;

            this.setActiveFilter(filterEl);
            this.filterArticles(filter);
            this.updateContent(filter);
        }
    }

    fill(countOverride = null) {
        
        // remove the old ones, add new
        const grid = this.el.querySelector('.grid');
        const existingFillers = this.el.querySelectorAll('.filler');
        
        forEach(existingFillers, filler => {
            grid.removeChild(filler);
        });
        
        const n = isNull(countOverride) ? this.articles.length : countOverride;
        const bp = Config.get('breakpoint');
        const perRow = bp >= itemsPerRow.length ? itemsPerRow[itemsPerRow.length - 1] : itemsPerRow[bp];

        if (n % perRow === 0) {
            return;
        }

        const gaps = perRow - (n % perRow);
        const fillers = clone(this.allFilters).splice(0, gaps);

        // add new
        forEach(fillers, filler => {
            const node = document.createElement('div');

            node.className = 'tile filler';
            node.innerHTML = `
                <a href="${filler.url}">
                    <span class="wrap">
                        <span class="title">${filler.title}</span>
                        <span class="hr"></span>
                        <span class="little-btn">Learn More</span>
                    </span>
                    <span class="mask"></span>
                </a>
                <img src="${filler.bgi}" alt="" class="bg">
            `;

            grid.appendChild(node);
        });
    }

    setHeights() {
        forEach(this.articles, article => {
            article.setAttribute('data-height', article.clientHeight + 50);
        });
    }

    setActiveFilter(el) {
        const filters = this.el.querySelectorAll('#project-filters li');

        forEach(filters, li => {
            li.classList.remove('current-tax');
        });

        el.classList.add('current-tax');
    }

    updateContent(slug) {
        this.el.classList.remove(...this.slugs);

        this.el.classList.add(slug);

        this.header.innerHTML = `${slug} Projects`;
    }

    filterArticles(filterEl) {
        const filter = typeof filterEl === 'string' ? filterEl : filterEl.getAttribute('data-filter-slug');
        let showingCount = 0;

        if (this.animation === 'shrink') {
            forEach(this.articles, article => {
                if (article.classList.contains(`category-${filter}`) || filter === 'all') {
    
                    if (article.clientHeight === 0) {
                        const diff = parseInt(article.getAttribute('data-height'), 10);
        
                        Animate(0, diff, {
                            duration: 500,
                            fn: 'easeOutQuad',
                            onStep: val => {
                                article.style.height = `${val}px`;
                            },
                            onFinish: () => {
                                article.style.height = `${diff}px`;
                            }
                        });
                    }
                } else {
                    if (article.clientHeight !== 0) {
                        const diff = parseInt(article.getAttribute('data-height'), 10);
        
                        Animate(diff, -diff, {
                            duration: 250,
                            fn: 'easeOutQuad',
                            onStep: val => {
                                article.style.height = `${val}px`;
                            },
                            onFinish: () => {
                                article.style.height = `0px`;
                            }
                        });
                    }
                }
            });
        } else {
            forEach(this.articles, article => {
                if (article.classList.contains(`${filter}`) || filter === 'all') {
                    this.grid.appendChild(article);
                    showingCount++;
                } else {
                    if (article.parentNode) {
                        article.parentNode.removeChild(article);
                    }
                }
            });

            this.fill(showingCount);
        }
    }

    bind() {
        this.el.addEventListener('click', evt => {
            const target = evt.target;
            
            if (target.matches('#project-filters a')) {
                const filter = target.getAttribute('data-filter-slug');

                this.filterArticles(target);
                this.updateContent(filter);
                this.setActiveFilter(target.parentNode);
                evt.preventDefault();
            }
        });
    }
}
